/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取商品预订单
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  uuid: string,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: order.GoodAdvanceRes;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/order/good-advance/${uuid}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
